export class UserOrgRole {
  private static APPROVED_STATUS: string = "APPROVED";
  roleName: string;
  statusCode: string;
  prodName: string;

  isApproved(): boolean {
    return this.statusCode === UserOrgRole.APPROVED_STATUS;
  }
}

export class AccessRequest {
  accReqId: string;
  requestedDate: string;
  roleName: string;
  statusCode: string;
  productName: string;
  productDisplayName: string;
  roleAdminType: string;
  productDescription: string;
}

export class UserOrg {
  private static ACTIVE_STATUS: string = "ACTIVE";
  mdmId: string;
  orgId: string;
  statusCode: string;
  orgName: string;
  cityName: string;
  stateCode: string;
  country: string;
  email: string;
  publicCode: string;
  userOrgRoles: Array<UserOrgRole>;
  accessReqDto: Array<AccessRequest>;

  /**
   * Determine if this organization assignment authorizes
   * to access the organization.
   */
  isAuthorized(): boolean {
    if (this.statusCode === UserOrg.ACTIVE_STATUS && this.userOrgRoles) {
      const index = this.userOrgRoles.findIndex(role => {
        return role.prodName === "TAA" && role.isApproved();
      });
      return index >= 0;
    }
    return false;
  }
}

export class User {
  private static BUSINESS_TYPE = "ACTB2B";
  private static CONSUMER_TYPE = "ACTB2C";
  private static CORPORATE_TYPE = "CORPORATE";
  private static NO_GLOBAL_ROLE = "NO_ROLE";
  givenName: string;
  familyName: string;
  userName: string;
  role: string;
  userType: string;
  loggedInUser: string;
  uid: string;

  organizations: Array<UserOrg>;

  isBusinessAccount(): boolean {
    return this.userType === User.BUSINESS_TYPE;
  }

  isConsumerAccount(): boolean {
    return this.userType === User.CONSUMER_TYPE;
  }

  isCorporateAccount(): boolean {
    return this.userType === User.CORPORATE_TYPE;
  }

  isRoleGlobal() {
    return this.role !== User.NO_GLOBAL_ROLE;
  }
}



// WEBPACK FOOTER //
// ./client/views/services/user.model.ts